import { render, staticRenderFns } from "./BarChartRankingVisitantes.vue?vue&type=template&id=a1da0ecc"
import script from "./BarChartRankingVisitantes.vue?vue&type=script&lang=js"
export * from "./BarChartRankingVisitantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports